import React from 'react'
import styles from './PopupSendDeposit.module.scss'
import { Icon } from 'components/Icon/Icon'
import { Input } from 'components/Input/Input'
import { Button } from 'components/Button/Button'
import { ModalPage } from 'components/ModalPage/ModalPage'
import { Cover } from 'components/Cover/Cover'
import { COVER_DATA } from 'components/Cover/consts'
import { PopupApprove } from './PopupApprove/PopupApprove'
import { Attention } from 'components/Attention/Attention'
import { notify } from 'layout/Notification'
import { PopupAddExtMetamask } from './PopupAddExtMetamask/PopupAddExtMetamask'
import { useAppSelector } from 'redux/hooks'

type Props = {
    onClose: () => void,
    deposite: null | number
}

export function PopupSendDeposit(props: Props) {
    const { account } = useAppSelector((state) => state.root)
    const [credentials, setCredentials] = React.useState({
        deposit: props.deposite.toString(),
        name: null,
        img: COVER_DATA[0].value
    })

    const [modalApprove, setModalApprove] = React.useState(false)
    const [modalAddMetamask, setModalAddMetamask] = React.useState(false)
    const [isApprove, setisApprove] = React.useState(false)

    function handleCredentials(target) {
        setCredentials({
            ...credentials,
            [target.name]: target.value,
        })
    }

    function onSubmit(event: React.FormEvent<HTMLFormElement>) {
        event.preventDefault()
    }

    function handleCover(item) {
        setCredentials({
            ...credentials,
            img: item.value,
        })
    }

    function handleDeposit() {
        if (!account) {
            setModalAddMetamask(true)
            return
        }
    }

    function handleApprove() {
        setisApprove(true)
        setModalApprove(false)
        notify('Allowance is set up', 'Now you can make a drizzle')
    }

    function openApprove() {
        setModalApprove(true)
    }

    function closeApprove() {
        setModalApprove(false)
    }

    function closeAddMetamask() {
        setModalAddMetamask(false)
    }


    return (
        <ModalPage onClose={props.onClose} hideCross={false}>
            <div className={styles['modal']}>
                <div className={styles['wrapper']}>
                    <form className={styles['form']} onSubmit={onSubmit}>
                        <div className={styles['form__header']}>
                            <span className={styles['title']}>New deposit</span>
                            <span className={styles['description']}>
                                Choose deposit size below,
                                <br />
                                and send the link to whom you love
                            </span>
                        </div>
                        <Input
                            label='Deposit size'
                            type='text'
                            name='deposit'
                            value={credentials.deposit}
                            onChange={handleCredentials}
                        />
                        <Input
                            label='Your name (optional)'
                            type='text'
                            name='name'
                            onChange={handleCredentials}
                        />
                        <Cover label='Cover' name='cover' onChange={handleCover} />
                        <div className={styles['button']}>
                            {!isApprove && (
                                <>
                                    <div className={styles['attention']}>
                                        <Attention color='blue'>
                                            Insufficient allowance. Drizzle needs your approval to move funds in order to make a deposit. Please accept in Metamask
                                        </Attention>
                                    </div>
                                    <Button size='l' type='primary' onClick={openApprove}>
                                        Set allowance
                                    </Button>
                                </>
                            )}
                            <Button
                                size='l'
                                type='primary'
                                onClick={handleDeposit}
                                disabled={!isApprove}
                            >
                                Make a ${credentials.deposit} deposit
                            </Button>
                        </div>
                    </form>
                    <div className={styles['content']}>
                        <div className={styles['content__picture']}>
                            <img
                                src={credentials.img}
                                className={styles['img']}
                                alt='drizzle send deposit'
                            />
                            <div className={styles['extra']}>
                                <div className={styles['extra__text']}>Here's how your Drizzle will appear for the receiver</div>
                                <div className={styles['extra__icon']}>
                                    <Icon name='arrow_vector_down' />
                                </div>
                            </div>
                        </div>
                        <div className={styles['info']}>
                            <span className={styles['info__title']}>
                                Leopold committed a ${credentials.deposit} deposit to your name
                            </span>
                            <span className={styles['info__desription']}>
                                You will be collecting interest from This deposit
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            {modalApprove && <PopupApprove onClose={closeApprove} onApprove={handleApprove} />}
            {modalAddMetamask && <PopupAddExtMetamask onClose={closeAddMetamask} />}
        </ModalPage>
    )
}

